let subscription_all_btns = document.querySelectorAll('.subscription__types-container .btn');
let subscription_types = document.querySelectorAll('.subscription__types .btn');
let subscription_options = document.querySelectorAll('.subscription__options .btn');
let subscription_options_container = document.querySelector('.subscription__options');
let btn_onetimer = document.querySelector('.type__onetime');
let prices = document.querySelectorAll('.product__info-wrapper .price-item--regular');
let variant_input = document.querySelector('#main-prodct-form .product-form input[name="id"]');
let selling_plan_first = document.querySelector('.product-form input[name="selling_plan"]');
let option_30_days = document.querySelector('.subscription__option[data-variant-frequency="1"]');
let option_90_days = document.querySelector('.subscription__option[data-variant-frequency="3"]');
let option_180_days = document.querySelector('.subscription__option[data-variant-frequency="6"]');
let option_prices = document.querySelectorAll('.option__price');
let isPricePerDay = false;

if(subscription_all_btns){

    const toogleClass = (element, target) => {
        element.forEach(btn => {
            if (btn == target){
                btn.classList.add('btn__primary');
            }else{
                btn.classList.remove('btn__primary');
            }
        });
    }

    const change_product_form = target =>{
        let isSubscription = false;
        let new_variant_id;

        if (document.querySelector('.product__info-wrapper .subscription__types .btn.btn__primary').dataset.type == 'subscription' ) {
            isSubscription = true;
        }
        
        //change variant if product is subscription
        if (isSubscription){
            new_variant_id = document.querySelector('.product__info-wrapper .subscription__options .btn.btn__primary').dataset.variantIdSubscription;
        }else {
            new_variant_id = document.querySelector('.product__info-wrapper .subscription__options .btn.btn__primary').dataset.variantId;
        }

        //Update product form price
        let new_price;
        let month_price;
        if (document.body.classList.contains('template-suffix-dietbacs-funnel')){
            isPricePerDay = true;
        }

        if (isSubscription){
            if (isPricePerDay){
                new_price = (parseFloat(target.dataset.variantPriceSubscription ) / ((target.dataset.variantFrequency != null ? target.dataset.variantFrequency : 1) * 30)).toFixed(2);
                month_price = target.dataset.variantPriceSubscription;
            }else{
                new_price = target.dataset.variantPriceSubscription;
            }
           
        }else {
            //if 6 months already selected
            if (option_180_days.classList.contains('btn__primary')){
                if (isPricePerDay){
                    new_price = (parseFloat(option_180_days.dataset.variantPrice ) / 180).toFixed(2);
                    month_price = option_180_days.dataset.variantPrice;
                }else{
                    new_price = option_180_days.dataset.variantPrice;
                }
                
            }else{
                if (isPricePerDay){
                    new_price = (parseFloat(target.dataset.variantPrice ) / 90).toFixed(2);
                    month_price = target.dataset.variantPrice;
                }else{
                    new_price = target.dataset.variantPrice;
                }
                
            }    
        }
        if (!isPricePerDay){
            prices.forEach(price=>price.textContent = new_price);
        }else{
            document.querySelectorAll('.price-per-day').forEach(el => el.textContent = new_price);
            document.querySelectorAll('.price__per-months-amount').forEach(el => {
                el.textContent = month_price;
            });
            document.querySelectorAll('.month__label').forEach(el => {
                if (target.dataset.variantFrequency){
                    if (target.dataset.variantFrequency == '1'){
                        el.textContent = locales_variables.month;
                    }else{
                        el.textContent = locales_variables.months;
                    }
                }else{
                    if (target.dataset.type == 'subscription'){
                        el.textContent = locales_variables.month;
                    }else{
                        el.textContent = locales_variables.months;
                    }
                }
            });
        }
        

        //Update option prices
        option_prices.forEach(el => {
            if (isSubscription){
                el.textContent = el.closest('.subscription__option').dataset.variantPriceSubscription;
            }else {
                el.textContent = el.closest('.subscription__option').dataset.variantPrice;
            }
        });

        //Update variant id in product form
        variant_input.value = new_variant_id;

        //Change selling_plan
        
        let selling_plan_next = document.querySelectorAll('#main-prodct-form .product-form input[name="selling_plan"]');
        
        if (selling_plan_first){
           
            selling_plan_next.forEach(el=>el.remove());
            if(isSubscription){
                let copied_selling_input = selling_plan_first.cloneNode(true);
                copied_selling_input.value = document.querySelector('.product__info-wrapper .subscription__options .btn.btn__primary').dataset.sellingPlan;
                document.querySelector('#main-prodct-form .product-form form').insertAdjacentElement('afterbegin', copied_selling_input )
            }
        }  
    }

    const toogleBtnVisibility = event => {
        let target = event.target.closest('.btn'); 

        if (target.parentNode.closest('.subscription__types')) {
            toogleClass(subscription_types, target);

            //Hide 30 days option for onetimer and make 90 days active
            if (target.classList.contains('type__onetime')){
                option_30_days.style.display = 'none';
                option_30_days.classList.remove('btn__primary');
                if (!option_180_days.classList.contains('btn__primary')){
                    option_90_days.classList.add('btn__primary');
                }
            } else{ 
                //always make 30 days active when subscription is selected
                subscription_options.forEach(option => option.classList.remove('btn__primary'));
                option_30_days.style.display = 'flex';
                option_30_days.classList.add('btn__primary');

            } 

        }else {
            toogleClass(subscription_options, target);
        }

        change_product_form(target);
    }

    subscription_all_btns.forEach(btn => {
        btn.addEventListener('click', toogleBtnVisibility);
    });

    //url variants 
    let cur_url = location.search; 

    if (cur_url.indexOf('product-variant') > -1){
        let search_variant = cur_url.split('=')[1];
        subscription_options.forEach(el => el.classList.remove('btn__primary'));
        option_30_days.style.display = 'none';
        subscription_options.forEach(btn => {
            if(btn.dataset.variantId == search_variant){
                btn.classList.add('btn__primary');
                btn_onetimer.classList.add('btn__primary');
                document.querySelector('.type__subs').classList.remove('btn__primary');
                // subscription_options_container.classList.add('active');
                variant_input.value = search_variant;
                if (selling_plan_first) selling_plan_first.remove();
                prices.forEach(price=>price.textContent = btn.dataset.variantPrice);
            }
        })
    }

}
